<template>
    <div>
        <div class="container-header-main-rewards">
            <div class="dashboard-main mt-2">
                <carousel
                    v-if="arrDashboard.length > 0"
                    :responsive="configCarousel.responsive"
                    :lazyLoad="true"
                    :nav="false"
                    :rewind="false"
                    :loop="false"
                    :autoplay="true"
                    :center="true"
                >
                    <div
                        v-for="(v, k) in arrDashboard"
                        :key="k"
                        class="item-slide"
                        @click="clickDashboard(v)"
                    >
                        <img :src="v.image_url" class="img-detail" />
                    </div>
                </carousel>
            </div>
        </div>
    </div>
</template>
<script>
import Carousel from "vue-owl-carousel"; // https://github.com/s950329/vue-owl-carousel
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
import { SubDashboardConfigBuilder } from "@/core/Campaign/model/DashboardConfigModel.js";
import CacheHelper from "@/helper/CacheHelper.js";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
/**
 * @property {string} apiConfig (require) Dashboard config_list
 */
export default {
    name: "DashboardSlider",
    components: {
        Carousel
    },
    props: {
        apiConfig: String
    },
    data: function() {
        return {
            arrDashboard: [],
            configCarousel: {
                responsive: {
                    0: { items: 1.3 }
                }
            },
            cacheHelper: new CacheHelper(),
            profile: {},
            coinUser: "",
        };
    },
    created: function() {
        this.coinUser = this.cacheHelper.getCache(
            "BzbsUser"
        ).updated_points.points;
        this.getDashboard();
        this.getProfile();
    },
    methods: {
        getProfile() {
            BzbsApi.getProfile(
                this.cacheHelper.getCache("BzbsUser").token
            ).then(response => {
                this.profile = response.data;
            });
        },
        getDashboard: function() {
            var token = Account.getToken();
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());
            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(
                token,
                params,
                "nescafestreetcafe_promotion"
            ).subscribe(
                data => {
                    this.arrDashboard = data;
                },
                err => {
                    console.log(err);
                }
            );
        },
        clickDashboard: function(dashboard) {
            console.log("clickDashboard : ", dashboard.type);
            if (dashboard.type == "link") {
                window.open(dashboard.url, "_blank");
            } else if (dashboard.type == "campaign") {
                this.$router.push("/campaign/" + dashboard.id);
            }
        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseImage.scss";
@import "@/style/custom/owl.scss";
::v-deep .dashboard-main {
    margin: 5px;
    .detail-img {
        width: 100%;

        &.default {
            @include baseRatioImg(66.67%);
        }
    }
    .owl-stage-outer {
        padding: 5px 0;
    }
    .owl-item {
        opacity: 0.75;
        transition: all 0.3s ease-in-out;

        .item-slide {
            transform: scale(0.9);
            // max-height: 10rem;
        }

        &.center {
            opacity: 1;
            padding: 0 !important;

            .item-slide {
                transform: scale(1);
                // max-height: 10rem;
            }
        }
    }
    #detail_carousel {
        @include owl(rgba(255, 255, 255, 0.5), blue);
    }

    .img-detail {
        border-radius: 10px;
        width: 100%;
        height: auto;
        object-fit: cover;
        // max-height: 9.5rem;
    }
    @media (max-height: 680px) {
        .img-detail {
            // max-height: 7.5rem;
        }
        .owl-item {
            .item-slide {
                // max-height: 8rem;
            }
            &.center {
                .item-slide {
                    // max-height: 8rem;
                }
            }
        }
    }
    .owl-theme .owl-dots .owl-dot.active span {
        // background: #044437;
        // width: 22px;
        display: none;
    }
    .owl-theme .owl-dots .owl-dot span {
        // width: 8px;
        // height: 8px;
        // margin: 5px 2px;
        // background: #0444373b;
        display: none;
    }
    .owl-theme .owl-nav.disabled + .owl-dots {
        margin-top: 5px !important;
    }
    .owl-carousel.owl-drag .owl-item {
        padding: 0 6px;
    }
}
.bg-gray {
    background: #f5f5f5;
}
.container-header-main-rewards {
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    min-height: 12rem;
    @media (max-height: 680px) {
        .container-header-main-rewards { 
            max-height: 7.5rem;
        }
    }
    .wrapper-header-main {
        display: flex;
        padding: 5px 10px 0;
        .wrapper-header-left {
            .img-logo-new1 {
                width: 121px;
                height: 63px;
            }
        }
        .wrapper-header-right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 100%;
            height: 63px;
            .bg-point-user {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .img-bg-point {
                    z-index: 1;
                    position: absolute;
                }
                .img-coin-user {
                    // position: absolute;
                    // right: 130px;
                    // z-index: 2;
                    // margin-top: -3px;
                    margin-right: 3px;
                    width: 20px;
                    height: 20px;
                }
                .span-coin {
                    z-index: 2;
                    position: absolute;
                    margin-top: -3px;
                    right: 18px;
                    font-size: 18px;
                    color: #49883f;
                    .value-coin {
                        font-size: 22px;
                        color: #f25228;
                        line-height: 1.05;
                        font-family: "DBHelvethaiBold";
                    }
                }
            }
        }
    }
}
</style>
